import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html',
  styleUrls: ['./password.component.css']
})
export class PasswordComponent implements OnInit {
  @Input() placeholder;
  @Input() type;
  @Input() value;
  @Input() id;
  @Input() style;
  @Input() class;
  @Input() label;
  @Input() hint;
  @Input() control_type;
  @Input() required;
  @Input() error_msg;
  @Input() form: UntypedFormGroup;
  @Input() controlName;
  @Output() getValue = new EventEmitter();
  @Input() maxLength;
  @Input() label_block;
  @Input() disabled;
  @Input() verified_status;
  @Input() notes;
  @Input() reason;
  @Input() verification_required;
  random_id = 'password' + Math.floor((Math.random() * 10000) + 1) + Date.now();

  constructor() { }

  ngOnInit() {
  }

}
